import styled from "@emotion/styled";

export const EmptyStateContainer = styled.div`
  margin-top: 4rem;
  margin-bottom: 2rem;
`;
